import { StoreState } from '@/store';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { dateToString } from '@/utils/dateToString';
import { exportToExcel } from '@/utils/exportToExcel';
import { dateEndMustBeAfterDateStart } from '@/validators/dateEndMustBeAfterDateStart';
import { dateMustBeBeforeOrEqualThanToday } from '@/validators/dateMustBeBeforeOrEqualThanToday';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { GetReportRequirements, ResponseFilterRequirements, ResponseRequirementExcel, SelectedListToFilter } from '../../../../interfaces/reports/reports';
import { ReportsService } from '../../../../services/reports/reports.service';
import { dateRangeConstraintByMonths, oneMustBeActiveOneOfEach } from '../reports.validators';

@Component({
  selector: 'app-reports-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.css'],
})
export class RequestsComponent implements OnInit {
  @Input() assetList: SelectedListToFilter[] = [];
  @Input() typeRequestList: SelectedListToFilter[] = [];
  @Input() stateRequestList: SelectedListToFilter[] = [];
  @Input() resetFormControl: Subject<boolean> = new Subject<boolean>();
  @Input() assetIdSelectedControl = new FormControl([]);

  // isRequestLicenseReport: boolean = false;
  detailRequestsByFilter?: ResponseFilterRequirements[];
  gettingDetailsLicense: boolean = false;
  gettingLDetailsLicenseError: string = 'DEFAULT_VALUE';
  warning: boolean = false;
  pageCount: number = 0;
  listCountForPages: number[] = [];
  currentPage: number = 0;
  filterResult: string = 'request';

  lastSubmitData?: GetReportRequirements;

  @Input() gettingItemsList: boolean = true;
  @Input() gettingItemsListError: string = 'DEFAULT_VALUE';

  listFilterAllAssetToRequest: FormControl = new FormControl();
  listFilterAllTypeRequest: FormControl = new FormControl();
  listFilterAllStateRequest: FormControl = new FormControl();

  assetsListsControl: FormArray = new FormArray([]);
  typeRequestListsControl: FormArray = new FormArray([]);
  stateRequestListsControl: FormArray = new FormArray([]);

  controlForm: FormGroup = new FormGroup({});
  get pageNumberSelected(): FormControl {
    return this.controlForm.controls.pageNumberSelected as FormControl;
  }
  get dateFromReport(): FormControl {
    return this.controlForm.controls.fromDayReport as FormControl;
  }
  get dateUntilReport(): FormControl {
    return this.controlForm.controls.untilDayReport as FormControl;
  }
  // validaciones  calendarios

  get controlDateStartError(): string {
    const error = this.controlForm.controls.fromDayReport.errors;
    if (error) return error.description;
    return '';
  }
  // validaciones  calendarios

  get controlDateEndError(): string {
    const error = this.controlForm.errors;
    if (error && !error.hidden) return error.description;
    return '';
  }
  get listFilterControlAsset(): FormArray {
    return this.controlForm.controls.listFilterControlAssetRequest as FormArray;
  }

  constructor(
    private reportsServices: ReportsService,
    private store: Store<StoreState>,
  ) { }

  ngOnInit(): void {

    this.controlForm = new FormGroup({
      fromDayReport: new FormControl(null, [Validators.required, dateMustBeBeforeOrEqualThanToday()]),
      untilDayReport: new FormControl(null, [Validators.required]),
      listFilterControlAssetRequest: this.assetsListsControl,
      listFilterControlTypeRequest: this.typeRequestListsControl,
      listFilterControlStateRequest: this.stateRequestListsControl,
      pageNumberSelected: new FormControl(1),
    }, [
      dateEndMustBeAfterDateStart('fromDayReport', 'untilDayReport'),
      oneMustBeActiveOneOfEach('listFilterControlAssetRequest', 'listFilterControlTypeRequest', 'listFilterControlStateRequest'),
      dateRangeConstraintByMonths('fromDayReport', 'untilDayReport', 30),
    ]);

    let defaultValueWasSetted = false;
    this.assetsListsControl.valueChanges.subscribe({
      next: (value) => {
        if (!defaultValueWasSetted) {
          defaultValueWasSetted = true;
          for (
            let index = 0;
            index < this.assetsListsControl.controls.length;
            index++
          ) {
            const formControl = this.assetsListsControl.at(index);
            if (index === 0) {
              formControl.patchValue({ active: true });
            } else {
              formControl.patchValue({ active: false });
            }
          }
        }
        this.onCheckAssetChange(value);
      },
    });

    this.listFilterAllAssetToRequest.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.assetsListsControl.controls.length;
          index++
        ) {
          const formControl = this.assetsListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.listFilterAllTypeRequest.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.typeRequestListsControl.controls.length;
          index++
        ) {
          const formControl = this.typeRequestListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.listFilterAllStateRequest.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.stateRequestListsControl.controls.length;
          index++
        ) {
          const formControl = this.stateRequestListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.resetFormControl.subscribe((response) => {
      if (response) {
        this.controlForm.patchValue({
          fromDayReport: null,
          untilDayReport: null,
        });

        const defaultControl = this.assetsListsControl.at(0);
        defaultControl.patchValue({ active: true });
        for (
          let index = 1;
          index < this.assetsListsControl.controls.length;
          index++
        ) {
          const control = this.assetsListsControl.at(index);
          control.patchValue({ active: false });
        }
        for (
          let index = 0;
          index < this.typeRequestListsControl.controls.length;
          index++
        ) {
          const control = this.typeRequestListsControl.at(index);
          control.patchValue({ active: false });
        }
        for (
          let index = 0;
          index < this.stateRequestListsControl.controls.length;
          index++
        ) {
          const control = this.stateRequestListsControl.at(index);
          control.patchValue({ active: false });
        }

        // this.isRequestLicenseReport = false;
      }
    });
  }

  onGetDetailReport(formDataReport?: GetReportRequirements) {
    this.gettingDetailsLicense = true;
    const formData = this.controlForm.value;
    const selectedAsset = formData.listFilterControlAssetRequest.filter(
      (value: any) => value.active
    );
    const selectedTypeRequest = formData.listFilterControlTypeRequest.filter(
      (value: any) => value.active
    );
    const selectedStateRequest = formData.listFilterControlStateRequest.filter(
      (value: any) => value.active
    );
    if (
      selectedAsset.length > 0 ||
      selectedTypeRequest.length > 0 ||
      selectedStateRequest.length > 0
    ) {
      const assetFiltered: GetReportRequirements['assets'] = selectedAsset.map(
        (item: SelectedListToFilter) => ({ id: item.id })
      );
      const typeFiltered: GetReportRequirements['requirementsTypes'] =
        selectedTypeRequest.map((item: SelectedListToFilter) => ({
          id: item.id,
        }));
      const stateFiltered: GetReportRequirements['requirementsStatus'] =
        selectedStateRequest.map((item: SelectedListToFilter) => ({
          id: item.id,
        }));

      let getFormDataReport: GetReportRequirements = {
        dateStart: formData.fromDayReport as Date,
        dateEnd: formData.untilDayReport as Date,
        assets: assetFiltered,
        requirementsTypes: typeFiltered,
        requirementsStatus: stateFiltered,
        pageNumber: formData.pageNumberSelected,
      };

      this.lastSubmitData = getFormDataReport;
      if (formDataReport) {
        getFormDataReport = formDataReport;
      }
      this.currentPage = <number>this.lastSubmitData?.pageNumber;

      this.reportsServices
        .getReportRequirements(this.lastSubmitData)
        .subscribe({
          next: (res) => {
            this.detailRequestsByFilter = res;
            if (res[0]) {
              this.pageCount = <number>res[0].pageCount;
            }
            this.getListNumberCount(this.pageCount);
            this.gettingDetailsLicense = false;
            // this.isRequestLicenseReport = true;
          },
          error: () => {
            this.gettingDetailsLicense = false;
            this.gettingLDetailsLicenseError =
              'Hubo un problema  al obtener el detalle de las Licencias';
          },
          complete: () => { },
        });
    } else {
      this.warning = true;
    }
  }

  getListNumberCount(pageCount: number) {
    const pagsArr: number[] = [];
    for (let i = 0; i < pageCount; i++) {
      pagsArr.push(i + 1);
      this.listCountForPages = pagsArr;
    }
  }

  getNextpage() {
    const currentPage = this.pageNumberSelected.value;
    if (currentPage) {
      this.pageNumberSelected.setValue(currentPage + 1);
      this.onGetDetailReport(this.lastSubmitData);

    }
  }
  getPreviusPage() {
    this.pageNumberSelected.setValue(this.currentPage - 1);
    this.onGetDetailReport(this.lastSubmitData);
  }

  getGotoNumberPage(numberPageSelected: number) {
    if (numberPageSelected) {
      this.pageNumberSelected.setValue(numberPageSelected);
      this.onGetDetailReport(this.lastSubmitData);
    }
  }

  // exportToExcel() {
  // type Keys = keyof Omit<ResponseFilterRequirements, 'requirementStatusId'>;
  // const headers: Record<Keys, string> = {
  //   asset: 'Asset',
  //   requirementTypes: 'Tipo',
  //   driverName: 'Nombre Solicitante',
  //   requirementRequest: 'Nº solicitud',
  //   requirementStatus: 'Estado',
  //   createdAt: 'Fecha solicitud',
  // };
  // const dataWithDateParsed = this.detailRequestsByFilter.map((data) => ({
  //   ...data,
  //   requestDate: dateToString(data.requestDate),
  // }));
  // exportToExcel(headers, dataWithDateParsed as any, 'Solicitudes');
  // }

  exportToExcel() {
    type Keys = keyof ResponseRequirementExcel;
    const headers: Record<Keys, string> = {
      names: 'Nombres',
      lastnames: 'Apellidos',
      rut: 'Rut',
      email: 'Correo',
      gender: 'Género',
      emergencyContact: 'Contacto de Emergencia',
      emergencyPhoneNumber: 'Número de Emergencia(Fijo)',
      adress: 'Dirección',
      management: 'Gerencia',
      entityType: 'Empleado / Contratista',
      company: 'Empresa',
      businessUnit: 'Unidad de Negocio',
      charge: 'Cargo',
      shiftSystem: 'Sistema Turno',
      requestNumber: 'Número de Solicitud',
      workFlowStep: 'Etapa',
      lastApprovalDate: 'Fecha de Aprobación',
      vehicle: 'Vehículo',
      vehicleBrand: 'Marca',
      vehicleModel: 'Modelo',
      zone: 'Zona',
      licenseType: 'Tipo de Licencia',
      licenseNumber: 'Número Licencia',
      licenseExpirationDate: 'Fecha Vencimiento',
      restriction: 'Restricción',
      requesterName: 'Nombre Solicitante',
      requesterEmail: 'Correo Solicitante',
      requestDate: 'Fecha de Solicitud',
      delegatedByName: 'Delegada por',
      approvingSuperintendentName: 'Nombre Superintendente Aprobador',
      approvingSuperintendendentEmail: 'Correo Superintendente Aprobador',
      approvingSuperintendentRut: 'Rut Superintendente Aprobador',
    };
    if (this.lastSubmitData) {
      this.store.dispatch(loaderAnimationShow());
      this.reportsServices
        .getReportRequirementsToExcel(this.lastSubmitData)
        .subscribe({
          next: (dataToExcel) => {
            const dataWithDateParsed = dataToExcel.map((data) => ({
              ...data,
              requestDate: data.requestDate ? dateToString(data.requestDate) : '',
              lastApprovalDate: data.lastApprovalDate ? dateToString(data.lastApprovalDate) : '',
              licenseExpirationDate: data.licenseExpirationDate ? dateToString(data.licenseExpirationDate) : '',
            }));
            exportToExcel(headers, dataWithDateParsed as any, 'Solicitudes ');
            this.store.dispatch(loaderAnimationHide());
          },
        });
    }
  }

  onCheckAssetChange(value: Array<{ id: number; active: boolean }>) {
    this.assetIdSelectedControl.setValue(
      value.filter(({ active }) => active).map(({ id }) => id)
    );
  }
}
